import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { usePlatformFeature } from "@/partner/entities/platforms";
import { PlatformFeatureType } from "@/types/graphql/partner.generated";
import { DialogTabsMenu } from "@/partner/shared/components/DialogTabsMenu";
import { PagePaths } from "@/partner/shared/constants";
import { STREAM_TABS, type StreamTab } from "../model";

// Порт референсного StreamForm/Menu/Menu.js: вкладки живут в ?tab=, диалог
// не размонтируется при переключении (deep-linking на вкладку работает).
// JSX вынесен в общий DialogTabsMenu; здесь остаётся только
// фичефлаг-фильтрация вкладки «Опросы» и лейблы.
export const StreamTabsMenu: FC<{ tab: StreamTab }> = ({ tab }) => {
  const { t } = useTranslation();
  // Вкладка «Опросы» только при фичефлаге PLAYER_POLLS; откат ?tab=polls
  // на edit без флага считает StreamForm, сюда приходит уже готовый tab.
  const pollsEnabled = usePlatformFeature(PlatformFeatureType.PlayerPollsType);
  const tabs = STREAM_TABS.filter((name) => name !== "polls" || pollsEnabled);

  const labels: Record<StreamTab, string> = {
    edit: t("streams.form.tabs.edit"),
    broadcast: t("streams.form.tabs.broadcast"),
    restream: t("streams.form.tabs.restream"),
    studio: t("streams.form.tabs.studio"),
    monitoring: t("streams.form.tabs.monitoring"),
    polls: t("streams.form.tabs.polls"),
  };

  return (
    <DialogTabsMenu
      tabs={tabs}
      value={tab}
      labels={labels}
      basePath={PagePaths.streams}
    />
  );
};
